import { useState } from 'react';
import { Box, TextField, Button, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import Sidebar from '../../components/sidebar';
import Header from '../../components/header';
import { useNavigate } from 'react-router-dom';
import classService from '../../services/class_service';
import axios from "axios";


function AddKelas() {
  const [name, setNamaKelas] = useState('');
  const [location, setLokasi] = useState('');
  const [class_type_id, setJenisKelas] = useState('');
  const [capacity, setKapasitas] = useState('');
  const [calories, setKalori] = useState(100);
  const [datetime_start, setJamMulai] = useState('');
  const [datetime_end, setJamAkhir] = useState('');
  const [description, setDesc] = useState('');
  const [personal_trainer_id, setTrainer] = useState('');
  const [room, setNoRuangan] = useState('');
  const [slot, setSlot] = useState(0);
  const navigate = useNavigate();


  const handleCancel = () => {
    navigate(-1);
  };

  // TODO: handle isi2an form sama backend
  const handleNamaKelasChange = (event) => {
    setNamaKelas(event.target.value);
  };

  const handleTrainerChange = (event) => {
    setTrainer(event.target.value);
  };

  const handleLokasiChange = (event) => {
    setLokasi(event.target.value);
  };

  const handleDescChange = (event) => {
    setDesc(event.target.value);
  };

  const handleJenisKelasChange = (event) => {
    setJenisKelas(event.target.value);
  };

  const handleKapasitasChange = (event) => {
    setKapasitas(event.target.value);
  };

  const handleSlotChange = (event) => {
    setSlot(event.target.value);
  };

  const handleNoRuanganChange = (event) => {
    setNoRuangan(event.target.value);
  };

  const handleKaloriChange = (event) => {
    setKalori(event.target.value);
  };

  // const handleTanggalChange = (event) => {
  //   console.log(event.target.value)
  //   setTanggal(event.target.value);
  // };

  const handleJamMulaiChange = (event) => {
    setJamMulai(event.target.value);
  };

  const handleJamAkhirChange = (event) => {
    setJamAkhir(event.target.value);
  };

  // Handle for submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    const post = {
      datetime_start: datetime_start,
      datetime_end: datetime_end,
      room: room,
      capacity: capacity,
      name: name,
      description: description,
      location: location,
      personal_trainer_id: personal_trainer_id,
      class_type_id: class_type_id,
      calories: calories,
      slot: slot
    }
    const response = await classService.createOneClass(post);
    if (response.post) {
      alert("An error occurred while creating the class");
      navigate(-1); 
    } else {
      alert("Class created successfully");
      navigate(-1); 
    }
  }

  return (
    <>
      <Box sx={{ top: 0, left: 0, width: '100%', zIndex: 2 }}>
        <Header />
      </Box>
      <Box sx={{ position: 'absolute', top: 64, left: 0, height: '100%', zIndex: 2 }}>
        <Sidebar activeButton="Manajemen Kelas" />
      </Box>

      <Box sx={{ marginLeft:'280px', marginRight:'50px', p: 2 }}>
        <form onSubmit={handleSubmit}>

          {/* Input Nama */}
          <Box sx={{ mb: 2, backgroundColor: 'white', boxShadow: 3 }}>
            <TextField
              required
              fullWidth
              label="Nama"
              value={name}
              onChange={handleNamaKelasChange}
              variant="outlined" />
          </Box>

          {/* Input Lokasi */}
          <Box sx={{ mb: 2, backgroundColor: 'white', boxShadow: 3 }}>
          <FormControl fullWidth variant="outlined">
              <InputLabel id="location-select-label">Lokasi</InputLabel>
              <Select
                labelId="location-select-label"
                id="location-select"
                value={location}
                onChange={handleLokasiChange}
                label="lokasi"
              >
                <MenuItem value={'dmall'}>Dmall</MenuItem>
                <MenuItem value={'kartini'}>Kartini</MenuItem>
                <MenuItem value={'ekalos'}>Ekalos</MenuItem>
              </Select>
            </FormControl>
          </Box>

          {/* Input Jenis Kelas */}
          <Box sx={{ mb: 2, backgroundColor: 'white', boxShadow: 3 }}>
          <FormControl fullWidth variant="outlined">
              <InputLabel id="class-type-id-select-label">Jenis Kelas</InputLabel>
              <Select
                labelId="class-type-id-select-label"
                id="class-type-id-select"
                value={class_type_id}
                onChange={handleJenisKelasChange}
                label="Jenis Kelas"
              >
                <MenuItem value={'681bf3d0-fe29-11ed-adae-35bf4d1d3126'}>zumba</MenuItem>
                <MenuItem value={'437fee10-fa18-11ed-82fb-e50a1c84cc6c'}>aerobic</MenuItem>
                <MenuItem value={'1c8598f0-fa18-11ed-82fb-e50a1c84cc6c'}>body pump</MenuItem>
                <MenuItem value={'c1836900-fa17-11ed-82fb-e50a1c84cc6c'}>cardio dance</MenuItem>
                <MenuItem value={'e4a8c150-fa17-11ed-82fb-e50a1c84cc6c'}>hiit play</MenuItem>
              </Select>
            </FormControl>
          </Box>

          {/* Input Trainer */}
          <Box sx={{ mb: 2, backgroundColor: 'white', boxShadow: 3 }}>
          <FormControl fullWidth variant="outlined">
              <InputLabel id="personal-trainer-id-select-label">Personal Trainer</InputLabel>
              <Select
                labelId="personal-trainer-id-select-label"
                id="personal-trainer-id-select"
                value={personal_trainer_id}
                onChange={handleTrainerChange}
                label="Personal Trainer"
              >
                <MenuItem value={'99a09520-fac6-11ed-af82-27f0de03c063'}>Brasel Isnaen</MenuItem>
                <MenuItem value={'a53a2928-c63e-37f5-b79b-e8a588ed21ef'}>Ahmad Hermawanto</MenuItem>
                <MenuItem value={'c126bf40-0208-11ee-bd05-759e00a829ff'}>trainerku</MenuItem>
              </Select>
            </FormControl>
          </Box>

          {/* Input Capacity */}
          <Box sx={{ mb: 2, backgroundColor: 'white', boxShadow: 3 }}>
            <TextField
              required
              fullWidth
              label="Kapasitas"
              type="number"
              value={capacity}
              onChange={handleKapasitasChange}
              variant="outlined" />
          </Box>

          {/* Input Slot */}
          <Box sx={{ mb: 2, backgroundColor: 'white', boxShadow: 3 }}>
            <TextField
              required
              fullWidth
              label="Slot"
              type="number"
              value={slot}
              onChange={handleSlotChange}
              variant="outlined" />
          </Box>

          {/* Input No Ruangan */}
          <Box sx={{ mb: 2, backgroundColor: 'white', boxShadow: 3 }}>
            <TextField
              required
              fullWidth
              label="Nomor Ruangan"
              value={room}
              onChange={handleNoRuanganChange}
              variant="outlined" />
          </Box>

          {/* Input Kalori */}
          <Box sx={{ mb: 2, backgroundColor: 'white', boxShadow: 3 }}>
            <TextField
              required
              fullWidth
              label="Kalori"
              type="number"
              value={calories}
              onChange={handleKaloriChange}
              variant="outlined" />
          </Box>


          {/* Pilih Jam */}
          <Box sx={{ mb: 2, backgroundColor: 'white', boxShadow: 3 }}>
          <TextField
              required
              fullWidth
              label=""
              type="datetime-local"
              value={datetime_start}
              onChange={handleJamMulaiChange}
              variant="outlined" />
          </Box>

          <Box sx={{ mb: 2, backgroundColor: 'white', boxShadow: 3 }}>
          <TextField
              required
              fullWidth
              label=""
              type="datetime-local"
              value={datetime_end}
              onChange={handleJamAkhirChange}
              variant="outlined" />
          </Box>

          {/* Input Desc */}
          <Box sx={{ mb: 2, backgroundColor: 'white', boxShadow: 3 }}>
            <TextField
              required
              fullWidth
              label="Deskripsi"
              value={description}
              onChange={handleDescChange}
              variant="outlined" />
          </Box>

          <Button type="submit" variant="contained" sx={{ boxShadow: 5, textTransform: 'none', bgcolor: '#1D375C', color: 'white' }}>
            Add Kelas
          </Button>
          <Button variant="contained" sx={{ left:10 , boxShadow: 5, textTransform: 'none', bgcolor: '#FF5630', color: 'white' }}onClick={handleCancel}>Cancel</Button>
        </form>
      </Box></>
  );
}

export default AddKelas;